import { useQuery } from '@tanstack/react-query'
import { QUERY_KEYS } from '../../constants/queryKeys'
import { GetHistoryOperationRequest, getOperationHistory } from '../../api/history'

function useGetOperationHistory(request: GetHistoryOperationRequest) {
   return useQuery({
      queryKey: [QUERY_KEYS.GET_OPERATION_HISTORY, request],
      queryFn: () => getOperationHistory(request),
      enabled: !!request && !!request.memberId && !!request.operationId,
   })
}

export { useGetOperationHistory }
export default useGetOperationHistory
